/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { omit } from 'lodash';

import { DragLayer, TreeItem, itemDnD } from '@waca/ca-ui-toolkit';

import SelectHierarchyFilter from './SelectHierarchyFilter';

export default function(
	SelectHierarchyFilterType,
	itemType = 'ITEM_TYPE',
	TreeDragLayer = DragLayer
) {
	const TreeItemDnD = itemDnD(TreeItem, { dragItemType: itemType });

	return class SelectHierarchyFilterDnD extends Component<any, any> {
		static propTypes = {
			dragLayerRenderer: PropTypes.func,
			//			isActive: PropTypes.bool,
			onEndDrag: PropTypes.func,
			onBeginDrag: PropTypes.func,
			canDragNode: PropTypes.func,
		};

		tree: SelectHierarchyFilter;

		_dragLayerRenderer = ({ itemProps, currentOffset, droppable }) => {
			const dragLayerRenderFn = this.props.dragLayerRenderer;

			return (
				<TreeDragLayer currentOffset={currentOffset} droppable={droppable}>
					{dragLayerRenderFn(itemProps)}
				</TreeDragLayer>
			);
		};

		_getTreeItemProps = treeProps =>
			//		const { canDrop, onDrop } = this.props;
			//		const { draggingNodes } = this.state;
			//		const itemDragging = draggingNodes.indexOf(node) >= 0;

			({
				//			...getTreeItemProps(treeProps, node),
				//			dragging: itemDragging,
				// canDrop,
				// onDrop,
				...treeProps,
				canDragNode: this._canDragNode,
				onBeginDrag: this._onBeginDrag,
				onEndDrag: this._onEndDrag,
			});

		_canDragNode = itemProps => {
			const { index } = itemProps;
			const { canDragNode } = this.props;

			// get the payload from the tree
			const value = this.tree.getFromMap(index);

			// override default canDrag processing
			if (canDragNode) {
				return canDragNode(value);
			}

			// default canDrag processing just looks for isGetModeChildren property
			if (Object.prototype.hasOwnProperty.call(value, 'isGetMoreChildrenItem')) {
				return !value.isGetMoreChildrenItem;
			}

			return true;
		};

		_onBeginDrag = itemProps => {
			const { index } = itemProps;

			// get the payload from the tree
			const value = this.tree.getFromMap(index);

			const payload = { value, dragLayerRenderer: this._dragLayerRenderer };
			let newPayload;

			if (this.props.onBeginDrag) {
				newPayload = this.props.onBeginDrag(payload);
			}

			// this.setState({ draggingNodes: selected });
			return newPayload == null ? payload : newPayload;
		};

		// setTimeout 0 is required here to ensure that drag end state gets set after click events are fired
		_onEndDrag = () => {
			setTimeout(() => {
				// 	this.setState({ draggingNodes: [] });
				this.props.onEndDrag && this.props.onEndDrag();
			}, 0);
		};

		_connectToDnD = ref => {
			this.tree = ref;
		};

		initSpareTree = () => {
			this.tree.initSpareTree();
		};

		render() {
			const passThroughProps = omit(
				this.props,
				'dragLayerRenderer',
				'onBeginDrag',
				'canDragNode',
				'onEndDrag'
			);

			return (
				<SelectHierarchyFilterType
					TreeItemToUse={TreeItemDnD}
					{...passThroughProps}
					getTreeItemProps={this._getTreeItemProps}
					ref={this._connectToDnD}
				/>
			);
		}
	};
}
